import { gql, useLazyQuery } from "@apollo/client";
import type {
  IMediaMetaObjectQuery,
  IMetaObjectTypeQuery,
  IMetaobjectImageQuery,
  IMetaobjectQuery,
} from "@repo/shopify/queries/metaobject-gql";
import {
  mediaMetaobjectQuery,
  metaobjectImageQuery,
  metaobjectQuery,
  metaobjectTypeQuery,
} from "@repo/shopify/queries/metaobject-gql";

export default function useMetaObjectQuery({ handle }: { handle: string }) {
  const [fetchMetaObject, { data: metaObjectData, loading: metaObjectLoading }] = useLazyQuery<IMetaobjectQuery>(
    gql(metaobjectQuery.query),
    {
      variables: { type: handle, first: 30, reverse: true },
      fetchPolicy: "no-cache",
      onError: (error) => {
        throw new Error(error.message);
      },
    },
  );

  const [fetchMetaObjectMedia, { data: metaObjectMediaData, loading: metaObjectMediaLoading }] =
    useLazyQuery<IMediaMetaObjectQuery>(gql(mediaMetaobjectQuery.query), {
      variables: { type: handle, first: 50, sort: "CREATED", reverse: false },
      onError: (error) => {
        throw new Error(error.message);
      },
    });

  const [fetchMetaObjectType, { data: metaObjectTypeData, loading: metaObjectTypeLoading }] =
    useLazyQuery<IMetaObjectTypeQuery>(gql(metaobjectTypeQuery.query), {
      variables: { type: handle, first: 10, reverse: true },
      fetchPolicy: "no-cache",
      onError: (error) => {
        throw new Error(error.message);
      },
    });

  const [fetchMetaObjectImage, { data: metaObjectImageData, loading: metaObjectImageLoading }] =
    useLazyQuery<IMetaobjectImageQuery>(gql(metaobjectImageQuery.query), {
      variables: { type: handle, first: 30, reverse: false },
      fetchPolicy: "no-cache",
      onError: (error) => {
        throw new Error(error.message);
      },
    });

  return {
    fetchMetaObject,
    metaObjectData,
    metaObjectLoading,
    fetchMetaObjectMedia,
    metaObjectMediaData,
    metaObjectMediaLoading,
    fetchMetaObjectType,
    metaObjectTypeData,
    metaObjectTypeLoading,
    fetchMetaObjectImage,
    metaObjectImageData,
    metaObjectImageLoading,
  };
}
